/**
 * Rollen-Typen in Trouble Brewing
 */
export enum RoleType {
  TOWNSFOLK = 'townsfolk',
  OUTSIDER = 'outsider',
  MINION = 'minion',
  DEMON = 'demon',
}

/**
 * Rolle mit allen Eigenschaften
 */
export interface Role {
  id: string;
  type: RoleType;
  nameKey: string; // i18n key fuer den Namen
  descriptionKey: string; // i18n key fuer die Beschreibung
  abilityKey: string; // i18n key fuer die Faehigkeit
  rulesKeys: string[]; // i18n keys fuer relevante Regeln
  firstNightOrder?: number; // Reihenfolge in der ersten Nacht (optional)
  otherNightOrder?: number; // Reihenfolge in anderen Naechten (optional)
  setupReminder?: string; // Setup-Erinnerung
  reminders: string[]; // Liste von Erinnerungen
}

/**
 * Rollen-Filter Optionen
 */
export interface RoleFilter {
  type?: RoleType;
  searchQuery?: string;
}
